import { SelectionLevel, SelectionLevelProps } from '../../../types/general';
import styles from './styles.module.css';
import { Icon } from '../../index';
import { Icons } from '../../Icon/Icon';
import { ReactNode, useState } from 'react';
import ToggleIcon from '../../ToggleIcon/ToggleIcon';

interface SelectionLayoutLevelContainerProps {
    type: SelectionLevel;
    children: ReactNode;
    headerChildren?: ReactNode;
}

const SelectionLayoutLevelContainer = ({ type, children, headerChildren }: SelectionLayoutLevelContainerProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <details className={styles.containerLevel} open>
            <summary className={styles.containerLevelHeader}>
                {/*<button*/}
                {/*    type={'button'}*/}
                {/*    className={`${styles.button} ${isCollapsed ? styles.active : ''}`}*/}
                {/*    onClick={() => setIsCollapsed(!isCollapsed)}*/}
                {/*>*/}
                <ToggleIcon />

                {/*</button>*/}
                <h3>{SelectionLevelProps[type].title}</h3>

                {headerChildren}
            </summary>

            <div className={`${styles.content} ${isCollapsed ? '' : styles.open}`}>{children}</div>
        </details>
    );
};

export default SelectionLayoutLevelContainer;
